import { render } from "./tw-editor.vue?vue&type=template&id=1698e6fe"
import script from "./tw-editor.vue?vue&type=script&lang=js"
export * from "./tw-editor.vue?vue&type=script&lang=js"
script.render = render

export default script